/** Stripe subscription statuses as stored on `AddressSubscription.status`. */
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Incomplete"] = "incomplete";
    SubscriptionStatus["IncompleteExpired"] = "incomplete_expired";
    SubscriptionStatus["Trialing"] = "trialing";
    SubscriptionStatus["Active"] = "active";
    SubscriptionStatus["PastDue"] = "past_due";
    SubscriptionStatus["Canceled"] = "canceled";
    SubscriptionStatus["Unpaid"] = "unpaid";
    SubscriptionStatus["Paused"] = "paused";
})(SubscriptionStatus || (SubscriptionStatus = {}));
const BILLING_PORTAL_EXEMPT_STATUSES = [
    SubscriptionStatus.Canceled,
    SubscriptionStatus.Trialing,
];
const TRIALING_STATUS = SubscriptionStatus.Trialing;
/** True when the address should route to the Stripe billing portal (not the activation flow). */
export function hasBillingPortalSubscription(subscriptions = []) {
    return subscriptions.some((sub) => !BILLING_PORTAL_EXEMPT_STATUSES.includes(sub.status));
}
/** True when the address is signing up while already on a trialing subscription. */
export function isTrialingSignup(subscriptions = []) {
    return subscriptions.some((sub) => sub.status === TRIALING_STATUS);
}
